export enum LicenseActivationDenyCodes {
  REDEEM_NOT_VALID_YET = -32013,
}
